<template>
    <div class="toolCont" :class="theme">
        <div class="layout">
            <h6>留学必备神器</h6>
            <div class="flex-ac flex-c fw" style="gap: 20px;">
                <div v-for="(it, i) in toolList" class="toolItem flex-ac flex-start pointer" :key="i"
                    :style="{ background: it.bg }">
                    <img :src="it.img" :title="it.alt">
                    <span :style="{ color: it.fColor }">{{ it.title }}</span>
                </div>
            </div>
            <div class="showMore flex-ac flex-c">
                <p class="flex-ac pointer">
                    <img src="@/assets/img/showMore.png" alt="" style="z-index:1;">
                    <img src="@/assets/img/showMore2.png" alt="" style="z-index: 2;" v-show="theme == 'dark'">
                    <span>查看更多</span>
                </p>
            </div>
        </div>
    </div>
</template>
<script setup>
import {
    ref,
    computed,
    onMounted,
    onBeforeMount,
    onBeforeUnmount,
    watch,
} from "vue";

import { storeToRefs } from "pinia";
import { useStore } from "@/store";
const store = useStore();
const { theme } = storeToRefs(store);

const toolList = ref([
    {
        img: require('@/assets/img/Frame@2x.png'),
        title: '2026申请日历',
        bg: '#E5F0FF',
        fColor: '#274F83'
    },
    {
        img: require('@/assets/img/Frame@2x (1).png'),
        title: '费用计算器',
        bg: '#FFF6E1',
        fColor: '#A67218'
    },
    {
        img: require('@/assets/img/Frame@2x (2).png'),
        title: '语言备考计划',
        bg: '#FFE6E3',
        fColor: '#A93A18'
    },
    {
        img: require('@/assets/img/Frame@2x (3).png'),
        title: '签证自查表',
        bg: '#EBFFE7',
        fColor: '#2A7821'
    },
])
</script>
<style lang="scss" scoped>
.toolCont {
    padding: 80px 0 90px;
    background: #fff;

    h6 {
        color: #393D4B;
        font-size: 24px;
        line-height: 34px;
        text-align: center;
        margin: 0 auto 48px;
    }

    .toolItem {
        width: 168px;
        height: 44px;
        background: #E5F0FF;
        border-radius: 28px 28px 28px 28px;
        padding: 12px 0 12px 20px;
        font-family: PingFang SC, PingFang SC;
        font-size: 14px;

        img {
            width: 20px;
            height: 20px;
            margin-right: 10px;
        }

        @media (max-width: 768px) {
            width: calc(40% - 10px);
        }
    }
}

.showMore {
    margin-top: 20px;

    span {
        font-size: 14px;
        color: #6C7B92;
        padding-left: 22px;
        line-height: 20px;
    }

    img {
        width: 16px;
        position: absolute;
        top: 2px;
        left: 0;
    }
}

.dark {
    background: #2C2D3B;

    h6 {
        color: #fff;
    }

    .showMore {
        span {
            color: #FFFFFF;
        }
    }
}
</style>